module.exports = __webpack_public_path__ + "img/CorrugatedBox1.b7168060.jpg";